import {HeaderTitle} from '../../../../common/HeaderTitle.jsx'
import {SimpleTable} from '../../../../common/simpleTable/SimpleTable.jsx'
import {tableListaUzytkownikow} from '../../lib/columns/tableListaUzytkownikow.jsx'
import {useListaUzytkownikowSystemu} from '../../../../../api/domain/profile/queries/useListaUzytkownikowSystemu.jsx'

const ViewListaUzytkownikow = () => {
    const titleName = 'Lista użytkowników'
    const {data: users} = useListaUzytkownikowSystemu()

    return (
        <>
            <HeaderTitle
                breadcrumbLinks={[{label: 'Lista profili'}, {label: titleName}]}
                home
                nav
                destination={'/oper/profile/lista'}
                size={'fs-3'}
                title={titleName}
            />

            <SimpleTable
                detailKey={'oper_profile_uzytkownicy'}
                columns={tableListaUzytkownikow}
                data={users}
            />
        </>
    )
}

export default ViewListaUzytkownikow
